export interface FetchClassificationRequest {
    type: string;
    cid: string;
}

export type FetchClassificationResponse = {
    title: string;
    content: string;
}[];

export interface FetchClassificationApi {
    fetchClassification(params: FetchClassificationRequest): Promise<FetchClassificationResponse>
}

export const FetchClassificationApi = Symbol.for('FetchClassificationApi');

